import { MessageCircle, Phone } from 'lucide-react';
import { site } from '../../constants/site';
import { buildWhatsAppUrl } from '../../utils/whatsapp';

export function FloatingButtons() {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3">
      <a
        href={buildWhatsAppUrl()}
        target="_blank"
        rel="noreferrer"
        aria-label="Open WhatsApp chat"
        className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg ring-4 ring-[#25D366]/20 transition hover:scale-105"
      >
        <MessageCircle className="h-5 w-5" />
      </a>
      <a
        href={`tel:${site.phone.replace(/\s/g, '')}`}
        aria-label="Call Skand Tech Hub"
        className="flex h-12 w-12 animate-pulse items-center justify-center rounded-full bg-ink-950 text-gold-300 shadow-lg ring-4 ring-gold-300/20 transition hover:scale-105"
      >
        <Phone className="h-5 w-5" />
      </a>
    </div>
  );
}
